import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function MentionsLegales() {
  return (
    <div className="px-5 pb-24 pt-36 sm:px-8 lg:pt-44" data-testid="mentions-legales-page">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary">Informations légales</p>
          <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight sm:text-4xl">Mentions légales</h1>
          <div className="my-10 h-px bg-border" />
        </Reveal>

        <Reveal delay={0.08}>
          <div className="space-y-10 text-base leading-relaxed text-muted-foreground" data-testid="mentions-legales-content">

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">1. Éditeur du site</h2>
              <p>
                Le site <strong className="text-foreground">intellix.fr</strong> est édité par <strong className="text-foreground">Intellix SAS</strong>, société de conseil en transformation numérique.
              </p>
              <ul className="mt-4 space-y-2 pl-1">
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Forme juridique : SAS</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Siège social : 4 Rue Marie Bracquemont, 85660 Saint Philbert De Bouaine</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>SIRET : 941 084 386 00015</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Numéro TVA intracommunautaire : FR76 941 084 386</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Directeur de la publication : Thomas Codet</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Email : <a href="mailto:tcodet@intellix.fr" className="text-primary hover:text-foreground transition-colors">tcodet@intellix.fr</a></span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Téléphone : <a href="tel:+33259604281" className="text-primary hover:text-foreground transition-colors">+33 2 59 60 42 81</a></span></li>
              </ul>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">2. Hébergement</h2>
              <p>
                Les informations relatives à l'hébergeur seront complétées prochainement.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">3. Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, logo, graphismes, icônes, vidéos, sons, logiciels, bases de données, etc.) est la propriété exclusive d'Intellix SAS ou de ses partenaires. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">4. Limitation de responsabilité</h2>
              <p>
                Intellix s'efforce de fournir des informations aussi précises que possible. Toutefois, l'entreprise ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait de tiers partenaires.
              </p>
              <p className="mt-3">
                Les liens hypertextes mis en place vers d'autres sites ne sauraient engager la responsabilité d'Intellix quant au contenu de ces sites.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">5. Données personnelles</h2>
              <p>
                Les données personnelles collectées via le formulaire de contact sont traitées conformément au Règlement Général sur la Protection des Données (RGPD). Pour plus de détails, consultez notre <Link to="/politique-de-confidentialite" className="text-primary hover:text-foreground transition-colors">politique de confidentialité</Link>.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">6. Droit applicable</h2>
              <p>
                Les présentes mentions légales sont régies par le droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.
              </p>
            </section>

          </div>
        </Reveal>
      </div>
    </div>
  );
}
